import { render, staticRenderFns } from "./AssocSummaryChart.vue?vue&type=template&id=b6ed9164&"
import script from "./AssocSummaryChart.vue?vue&type=script&lang=ts&"
export * from "./AssocSummaryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports